/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountPaginationResponseAllOfDataInnerAffiliationsInner } from './AccountPaginationResponseAllOfDataInnerAffiliationsInner';
import {
    AccountPaginationResponseAllOfDataInnerAffiliationsInnerFromJSON,
    AccountPaginationResponseAllOfDataInnerAffiliationsInnerFromJSONTyped,
    AccountPaginationResponseAllOfDataInnerAffiliationsInnerToJSON,
    AccountPaginationResponseAllOfDataInnerAffiliationsInnerToJSONTyped,
} from './AccountPaginationResponseAllOfDataInnerAffiliationsInner';

/**
 * 
 * @export
 * @interface AccountPaginationResponseAllOfDataInner
 */
export interface AccountPaginationResponseAllOfDataInner {
    /**
     * アカウントID
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    accountId: string;
    /**
     * アカウント状態 (1:未連携, 2:連携済)
     * @type {number}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    status: number;
    /**
     * アカウント名
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    accountName: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    email: string;
    /**
     * 利用者種別 (1:全権管理者, 2:組織管理者, 3:一般)
     * @type {number}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    role: number;
    /**
     * 追加権限リスト（1: 個人情報閲覧、2: 配車、3: マスター登録、4: 返金）
     * @type {Array<number>}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    permissions: Array<number>;
    /**
     * 楽観ロック制御用のバージョン番号
     * @type {number}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    version: number;
    /**
     * include_organization=true の場合に追加される、アカウントが所属する組織情報の一覧
     * @type {Array<AccountPaginationResponseAllOfDataInnerAffiliationsInner>}
     * @memberof AccountPaginationResponseAllOfDataInner
     */
    affiliations: Array<AccountPaginationResponseAllOfDataInnerAffiliationsInner>;
}

/**
 * Check if a given object implements the AccountPaginationResponseAllOfDataInner interface.
 */
export function instanceOfAccountPaginationResponseAllOfDataInner(value: object): value is AccountPaginationResponseAllOfDataInner {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('accountName' in value) || value['accountName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('affiliations' in value) || value['affiliations'] === undefined) return false;
    return true;
}

export function AccountPaginationResponseAllOfDataInnerFromJSON(json: any): AccountPaginationResponseAllOfDataInner {
    return AccountPaginationResponseAllOfDataInnerFromJSONTyped(json, false);
}

export function AccountPaginationResponseAllOfDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountPaginationResponseAllOfDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['account_id'],
        'status': json['status'],
        'accountName': json['account_name'],
        'email': json['email'],
        'role': json['role'],
        'permissions': json['permissions'],
        'version': json['version'],
        'affiliations': ((json['affiliations'] as Array<any>).map(AccountPaginationResponseAllOfDataInnerAffiliationsInnerFromJSON)),
    };
}

export function AccountPaginationResponseAllOfDataInnerToJSON(json: any): AccountPaginationResponseAllOfDataInner {
    return AccountPaginationResponseAllOfDataInnerToJSONTyped(json, false);
}

export function AccountPaginationResponseAllOfDataInnerToJSONTyped(value?: AccountPaginationResponseAllOfDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['accountId'],
        'status': value['status'],
        'account_name': value['accountName'],
        'email': value['email'],
        'role': value['role'],
        'permissions': value['permissions'],
        'version': value['version'],
        'affiliations': ((value['affiliations'] as Array<any>).map(AccountPaginationResponseAllOfDataInnerAffiliationsInnerToJSON)),
    };
}

